import React, { useState, useEffect } from 'react'
import Switch from '@mui/material/Switch';
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux';
import { DateTime } from 'luxon';
import md5 from 'md5';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { ReactComponent as More } from '../../../assets/new-icons/plus.svg';
import { ReactComponent as Less } from '../../../assets/new-icons/minus.svg';
import { setStimaGlobale, setStimeMinime } from '../../../features/StimeSlice'

function Step1({ next }) {
    const dispatch = useDispatch()
    const [set, setSwitch] = useState(false)
    const customerId = useSelector((user) => user.user.info.customer_id)
    const stimeMinime = useSelector((user) => user.stime.stimeMinime)
    const [globalMonthValues, setGlobalMonthValues] = useState([])
    const [valoreMin, setValMin] = useState()
    const [globalValue, setGlobalValue] = useState()
    const token = md5(customerId + DateTime.now().toFormat('y-MM-dd') + 'ApPeNrIcA')

    useEffect(() => {
        window.scrollTo(0, 0)
        init()
    }, [])

    const init = async () => {
        const getStime = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getStime.php?customer_id=${customerId}`;
        const { data } = await axios.get(getStime)
        dispatch(setStimeMinime(data.stime_minime))
        const arrayValues = data.stime_minime.map((r) => r.consumo)
        setGlobalMonthValues(arrayValues);
        dispatch(setStimaGlobale(Math.max.apply(Math, arrayValues)))
        setGlobalValue(Math.max.apply(Math, arrayValues))
    }

    const saveStime = async () => {
        const arrayMonths = '&mese[]=1&mese[]=2&mese[]=3&mese[]=4&mese[]=5&mese[]=6&mese[]=7&mese[]=8&mese[]=9&mese[]=10&mese[]=11&mese[]=12'
        const monthValues = set ? globalMonthValues : Array(12).fill(globalValue)
        const arrayValue = monthValues.map(v => `&valore[]=${v}`).join('')
        
        const setStima = `https://my.revoluce.it/area_utente/gestione/api/customers/setStime.php?customer_id=${customerId}&token=${token}${arrayMonths}${arrayValue}`
        const { data } = await axios.get(setStima)
        next()
    }
    
    const decreaseMonthValue = (index) => {
        if (stimeMinime[index].consumo < globalMonthValues[index]) {
            globalMonthValues[index]--
            setGlobalMonthValues([...globalMonthValues])
        }
    }

    const increaseMonthValue = (index) => {
        globalMonthValues[index]++
        setGlobalMonthValues([...globalMonthValues])
    }

    return (
        <>
            <p className="main">Che tipo di stima vuoi?</p>
            <p className="secondary">Puoi personalizzare il consumo stimato per ogni mese dell'anno in base ai tuoi dati storici.</p>
            <div className="boxSwitch">
                <div className="choise start">
                    <p className={`main ${set ? '' : 'off'}`}>Uguale</p>
                    <p className='secondary'>Per ogni mese</p>
                </div>
                <div className="switch">
                    <Switch onChange={() => setSwitch(!set)} />
                </div>
                <div className="choise end">
                    <p className={`main ${set ? 'on' : ''}`}>Diverso</p>
                    <p className='secondary'>Per ogni mese</p>
                </div>
            </div>
            {set ? (
                <>
                    <div className="single">
                        <div className="months">
                            {stimeMinime && stimeMinime.map((stima, i) => (
                                <div className="month" key={i}>
                                    <p className='monthName'>
                                        {DateTime.fromObject({ month: stima.mese }).toFormat('MMMM')}
                                    </p>
                                    <div className="change">
                                        <span className="less" onClick={() => decreaseMonthValue(i)}><Less /></span>
                                        <input type="number" placeholder={`${globalMonthValues[i]} kWh`} />
                                        <span className="more" onClick={() => increaseMonthValue(i)}><More /></span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="buttonActivate single">
                        <button disabled={stimeMinime && globalMonthValues.some((v, i) => v < stimeMinime[i].consumo)} onClick={() => saveStime()}>
                            Avanti <ArrowForwardIos fontSize='18px' />
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <div className="global">
                        <span className="less" onClick={() => valoreMin === globalValue ? null : setGlobalValue(globalValue - 1)}><Less /></span>
                        <input type="number" value={globalValue} placeholder='350 kWh' onChange={(e) => setGlobalValue(e.target.value)} />
                        <span className="more" onClick={() => setGlobalValue(globalValue + 1)}><More /></span>
                    </div>
                    <p className="label">Puoi diminuire il tuo consumo stimato fino alla metà della nostra previsione</p>
                    <div className="buttonActivate">
                        <button disabled={valoreMin > globalValue ? true : false} onClick={() => saveStime()}>Avanti <ArrowForwardIos fontSize='18px' /></button>
                    </div>
                </>
            )}

        </>
    )
}

export default Step1
